// extracted by mini-css-extract-plugin
module.exports = {"sticky-phone-button":"cta_sticky-phone-button__L1vYv","sticky-phone-button2":"cta_sticky-phone-button2__tirGu"};